var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayArrow = function SvgPlayArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5100",
    d: "M25.5 14.134a1 1 0 0 1 0 1.732l-24 13.856a1 1 0 0 1-1.5-.866V1.144A1 1 0 0 1 1.5.278z"
  })));
};
export { SvgPlayArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAyNiAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1LjUgMTQuMTM0QzI2LjE2NjcgMTQuNTE4OSAyNi4xNjY3IDE1LjQ4MTEgMjUuNSAxNS44NjZMMS41IDI5LjcyMjRDMC44MzMzMjkgMzAuMTA3MyAtMS40MjYxNGUtMDYgMjkuNjI2MiAtMS4zOTI0OWUtMDYgMjguODU2NEwtMS44MTEyMmUtMDcgMS4xNDM1OUMtMS40NzQ3M2UtMDcgMC4zNzM3ODkgMC44MzMzMzMgLTAuMTA3MzMzIDEuNSAwLjI3NzU2N0wyNS41IDE0LjEzNFoiIGZpbGw9IiNGRjUxMDAiLz4KPC9zdmc+Cg==";